<template>
  <div class="single-column-content pa-5 ma-3 text-xs-center" >
    <page-title :title="'Verifying'"></page-title>
    <h1 class="title mb-5" >Verifying</h1>
    <v-progress-circular v-if="!msg" indeterminate ></v-progress-circular>
    <h3 class="ma-3 text-md-center" v-if="msg" v-html="msg"></h3>
  </div>
</template>

<script>
import userApi from '@/api/user'
import routes from '@/route_names'

export default {
  name: 'Verifying',
  created: function() {
    const vm = this
    userApi.verifyUser(this.$router.currentRoute.query.token).then(function(data){
      if(data.data.status === 'OK') {
        vm.$router.push({
            name: routes.APP
          })
      }
      else{
        vm.msg = 'Your verification seems failed due to an expired token.'
      }
    })
  },
  data(){
    return {
      msg: null
    }
  },
  computed: {},
  methods: {
    
  }
}
</script>

<style lang="stylus">
@require "common.styl"
    .single-column-content {
        width 500px
    }
</style>
